import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { MeasureReference } from "src/app/domain/GS/measure-reference";
import { CoreData } from "src/app/tools/core-data/core-data";
import { LoadingTask } from "src/app/tools/ui/loading-task";
import { environment } from "src/environments/environment";
import { BaseService } from "../base.service";

@Injectable({
    providedIn: 'root',
})
export class MasterDataService extends BaseService {

    private serviceUrl = `${environment.GSServiceBaseUrl}api/masterdata`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }


    getAllMeasureReferences() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/AllMeasureReferences`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAllMeasureReferences(')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: MeasureReference[]) => {
                return response.map((item: MeasureReference) => {
                    return MeasureReference.mapFromJSON(item);
                });
            }));
    }

}